/**
 * CoLab Header Module
 * Sticky header та scroll effects
 */

let header = null;
let lastScroll = 0;
const scrollThreshold = 50;

function handleScroll() {
    const currentScroll = window.pageYOffset;

    if (currentScroll > scrollThreshold) {
        header.classList.add('is-scrolled');
    } else {
        header.classList.remove('is-scrolled');
    }

    // Optional: hide on scroll down, show on scroll up
    // if (currentScroll > lastScroll && currentScroll > 200) {
    //     header.classList.add('is-hidden');
    // } else {
    //     header.classList.remove('is-hidden');
    // }

    lastScroll = currentScroll;
}

function bindEvents() {
    window.addEventListener('scroll', handleScroll, { passive: true });
}

function init() {
    header = document.querySelector('.header');
    if (!header) return;

    bindEvents();
    handleScroll();
}

export const Header = {
    init
};
